import { Box, Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import Button from 'js/components/elements/editors/mui/Button';
import { ROUTE_CONNECT } from 'new/constants/pathnames';
import styles from './EmptyProjectState.module.scss';
import { useRestrictedTiers } from 'new/hooks/useRestrictedTiers';

interface EmptyProjectStateProps {
  projectId: number;
  onCreateFlowClick?: () => void;
}

const MessageContent = ({ children }: { children?: React.ReactNode }) => (
  <Box className={styles.container}>
    <Box className={styles.content}>
      <div className={styles.title}>You haven't added any flows to this project yet.</div>
      <div className={styles.subtitle}>
        Get started by creating a new flow or moving an existing flow.
      </div>
    </Box>
    {children}
  </Box>
);

const EmptyProjectState: React.FC<EmptyProjectStateProps> = ({ onCreateFlowClick }) => {
  const { hasExpressTierLimitedAccess } = useRestrictedTiers();
  const handleCreateFlowClick = (e: React.MouseEvent) => {
    try {
      onCreateFlowClick?.();
    } catch (err) {
      console.error('Error creating new flow:', err);
    }
  };

  if (hasExpressTierLimitedAccess) return <MessageContent />;

  return (
    <MessageContent>
      {/* 
      //TODO: Replace this with the new flow button. Not urgent.
      <Link
        className="undecorated-link"
        to={`${ROUTE_CONNECT}/flows/select-type`}
        onClick={handleCreateFlowClick}>
        <Button
          variant="outlined"
          size="small"
          data-testid="create-new-flow-button"
          className={styles.createButton}>
          Create New Flow
        </Button>
      </Link> */}
    </MessageContent>
  );
};

export default EmptyProjectState;
